import $ from 'jquery';
import { Cookie, Popup } from '../utilities';
import { refGet } from "../queries";

// отключили сообщение от спонсора, 5.05.2022
// (async function () {
//     const refId = Cookie.get('REF')
//     if (!refId) {
//         return;
//     }
//     const refIsPreviewed = Cookie.get('REF_IS_PREVIEWED')
//     if (+refIsPreviewed !== 1) {
//         const response = await refGet(refId);
//         Cookie.set('REF_IS_PREVIEWED', 1);
//         if (response.item.previewInfo ?? false) {
//             Popup.showContent('Сообщение от спонсора', response.item.previewInfo);
//         }
//     }
// })();


